module.exports = __webpack_public_path__ + "6b9412ffa0722eaeb1733f7aefd4b04d.jpg";